import { Component, OnInit, Input } from '@angular/core'
import { QuoteReviewService } from '../../services/quote-review.service'
import { Observable, of } from 'rxjs'
import { User, AuthService } from '@spartacus/core'
import { QuoteDataService } from '../../../quote-checkout/services/quote-data.service'
import { QuoteCheckoutService } from '../../../quote-checkout/services/quote-checkout.service'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { Router } from '@angular/router'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'

@Component({
  standalone: false,
  selector: 'vs-quotation-details',
  templateUrl: './quotation-details.component.html',
  styleUrls: ['./quotation-details.component.scss'],
})
export class QuotationDetailsComponent implements OnInit {
  @Input() customerProjectName: any
  @Input() rfqType
  @Input() endUserIndustry
  @Input() legalEntity
  isLoggedIn = false
  reviewData: any
  quotationData: any
  isLoggedinUser = false
  public cartId
  public cartStatus
  public userType
  user$: Observable<User>
  loggedIn: boolean
  cartLoaded = false
  cartData: any
  cartData$: Observable<any>
  productData: any
  legalEntityCollection: any
  orderTypeData$: Observable<any>
  rfqTypes = []
  rfqTypeName: any
  constructor(
    private quoteDataService: QuoteDataService,
    private quoteCheckoutService: QuoteCheckoutService,
    private quoteService: QuoteCartService,
    private auth: AuthService,

    private router: Router,
    private quoteReviewService: QuoteReviewService,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
    })
    this.fetchLegalEntities()
    this.getOrderType()
  }

  fetchLegalEntities() {
    this.quoteService.retainLegalEntityCollection.subscribe((data) => {
      this.legalEntityCollection = data
    })
  }

  fetchLegalEntityName(code) {
    if (
      this.legalEntityCollection !== undefined &&
      this.legalEntityCollection.length > 0
    ) {
      for (let entity of this.legalEntityCollection) {
        if (entity.code === code) {
          return entity.value
        }
      }
    }
    return ''
  }
  getOrderType() {
    this.orderTypeData$ = this.quoteCheckoutService.getOrderType(this.userType)
    this.orderTypeData$.subscribe((order: any) => {
      this.rfqTypes = order['orderType']
      this.getOrderByName(this.rfqType)
    })
  }
  getOrderByName(code) {
    this.rfqTypes.forEach((element) => {
      if (element.code === code) {
        this.rfqTypeName = element.name
      }
    })
  }
}
